import { render, staticRenderFns } from "./Familias.vue?vue&type=template&id=ae1825ac&"
import script from "./Familias.vue?vue&type=script&lang=js&"
export * from "./Familias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports